export const socialMediaLinks = {
  facebook: {
    url: 'https://www.facebook.com/intostudy',
    title: 'Link to INTOStudy Facebook Page',
  },
  instagram: {
    url: 'https://www.instagram.com/intostudy/',
    title: 'Link to INTOStudy Instagram Page',
  },
  twitter: {
    url: 'https://twitter.com/intostudy',
    title: 'Link to INTOStudy Twitter Page',
  },
  linkedin: {
    url: 'https://www.linkedin.com/school/621294/',
    title: 'Link to INTOStudy LinkedIn Page',
  },
};
